import "./JoinTeeListClub.module.css";
import Header from "@/reusable_sections/Header";
import MembershipJoinHero from "./sections/MembershipJoinHero";
import Membershipbenefits from "./sections/Membershipbenefits";
import Golfpassportintro from "./sections/Golfpassportintro";
import JoinTeeListClubForm from "./sections/JoinTeeListClubForm";
import FinalDiscoveryCTA from "./sections/FinalDiscoveryCTA";
import Footer from "@/reusable_sections/Footer";
export default function JoinTeeListClubPage() {
  return <div>
      <Header />
      <MembershipJoinHero />
      <Membershipbenefits />
      <Golfpassportintro />
      <JoinTeeListClubForm />
      <FinalDiscoveryCTA />
      <Footer />
    </div>;
}